<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { Datetime } from 'vue-datetime';

import { IRI } from '@/api';

export default {
  name: 'ModuleInvitationsEdition',
  components: {
    Datetime,
  },
  data() {
    return {
      initiated: false,
      localInvitationCourses: this.invitationCourses || [],
    };
  },
  computed: {
    ...mapState('course/collection', {
      courses: 'items',
    }),
    ...mapState('invitation/item', [
      'item',
    ]),
    invitationCourses: {
      get() {
        if (!this.item.invitationCourses) {
          return [];
        }
        return this.item.invitationCourses.map(invitationCourse => {
          if (!invitationCourse) {
            return;
          }
          return invitationCourse.course.replace(IRI.course, '');
        });
      },
      set(values) {
        const { item, localInvitationCourses } = this;
        const _values = values.map(value => `${IRI.course}${value}`);

        item.invitationCourses = item.invitationCourses.reduce((acc, invitationCourse) => {
          const valuesIndex = _values.findIndex(value => invitationCourse && value === `${invitationCourse.course}`);
          if (valuesIndex < 0) {
            return acc;
          }

          _values.splice(valuesIndex, 1);
          invitationCourse.expiresAt = item.expiresAt;
          acc.push(invitationCourse);
          return acc;
        }, []);

        _values.map(course => {
          const _invitationCourse = localInvitationCourses
                  .filter(invitationCourse => course === invitationCourse.course)
                  .pop() || {}
          ;

          item.invitationCourses.push({
            ..._invitationCourse,
            course: course,
            expiresAt: item.expiresAt,
          });
        });
        this.setItem(item);
      },
    },
    code: {
      get() {
        return this.item.code;
      },
      set(value) {
        const { item } = this;
        item.code = value;
        this.setItem(item);
      },
    },
    expiresAt: {
      get() {
        return this.item.expiresAt;
      },
      set(value) {
        const { item } = this;
        item.expiresAt = value;
        item.invitationCourses = item.invitationCourses.map(invitationCourse => {
          invitationCourse.expiresAt = value;
          return invitationCourse;
        });
        this.setItem(item);
      },
    },
  },
  methods: {
    ...mapActions('course/collection', {
      fetchCourses: 'fetch',
    }),
    ...mapActions('invitation/item', [
      'save',
      'fetch',
    ]),
    ...mapMutations('invitation/item', [
      'setItem',
      'reset',
    ]),
    localSave() {
      this.save()
        .then(res => {
          if (res.id) {
            return;
          }

          this.$router.push({ name: 'invitations-listing' });
        })
      ;
    },
  },
  created() {
    const { id } = this.$route.params;
    this.fetchCourses(false);

    if (!id) {
      this.reset();
      return;
    }

    this.fetch(id);
  },
  updated() {
    const { id } = this.$route.params;

    if (!id) {
      return;
    }

    if (this.initiated || !this.item.invitationCourses) {
      return;
    }

    this.localInvitationCourses = this.item.invitationCourses;
    this.initiated = true;
  }
};
</script>
<template>
  <div class="box">
    <h2>General</h2>
    <div class="form-group mt-3">
      <label for="course" class="d-block">Course</label>
      <select id="course" multiple class="form-control rounded-0" v-model="invitationCourses">
        <option value="" disabled>Select a Course</option>
        <option v-for="course in courses" :key="course.id" :value="course.id">{{ course.title }}</option>
      </select>
    </div>
    <div class="form-group mt-3">
      <label for="code" class="d-block">Code</label>
      <input id="code" class="form-control rounded-0" v-model="code" />
    </div>
    <div class="form-group mt-3">
      <label for="expiresAt" class="d-block">Expiration Date</label>
      <Datetime input-id="expiresAt" input-class="form-control rounded-0" v-model="expiresAt" />
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localSave">Save</button>
    </div>
  </div>
</template>
